import React, { memo } from 'react';

import { Block } from '../../components/core';
import { PortfolioCompositionContent } from './portfolio-composition-content';
import { PortfolioCompositionHeader } from './portfolio-composition-header';

import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { NoStrategyLevelsSelectedErrorWrapper } from '../../../studio-blocks/components/error-wrappers/NoStrategyLevelsSelectedErrorWrapper';

interface PortfolioCompositionBlockProps {
  id: string;
}

export const PortfolioCompositionBlock = memo(function InternalPortfolioCompositionBlock({
  id,
}: PortfolioCompositionBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <PortfolioCompositionHeader id={id} />
      </Block.Header>

      <Block.Content
        id={id}
        errorWrappers={[...COMMON_ERROR_WRAPPERS, MetricsErrorWrapper, NoStrategyLevelsSelectedErrorWrapper]}
      >
        <PortfolioCompositionContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
